import { fetchTipsViewState, setTipsViewStateTrue } from '@gp/services/global';

import type { Action, Reducer, Effect } from 'umi';
import type { IPayload, IRecord } from '@gp/types/global';

export interface ITipsViewState {
  loading: boolean;
  data: IRecord<boolean>;
}

type IUpdateTipsViewAction = Action<'updateTipsView'> & IPayload<{ loading: boolean; data: IRecord<boolean> }>;

export interface ITipsViewModel {
  namespace: string;
  state: ITipsViewState;
  effects: {
    getTipsViewState: Effect;
    updateTipsViewStateTrue: Effect;
  };
  reducers: {
    updateTipsView: Reducer<ITipsViewState, IUpdateTipsViewAction>;
  };
}

export const TIPS_VIEW_MODEL_NAMESPACE = 'dbg-model-tips-view';

const TipsViewModel: ITipsViewModel = {
  namespace: TIPS_VIEW_MODEL_NAMESPACE,
  state: {
    loading: true,
    data: {},
  },
  effects: {
    *getTipsViewState(action, { call, put }) {
      const { data } = yield call(fetchTipsViewState, { tags: action?.payload?.join(',') });
      yield put({
        type: 'updateTipsView',
        payload: { loading: false, data },
      });
    },

    *updateTipsViewStateTrue(action, { call, put, select }) {
      const payload = action?.payload || [];
      const tipsViewState: ITipsViewState = yield select((state: any) => state?.[TIPS_VIEW_MODEL_NAMESPACE] || {});
      yield put({
        type: 'updateTipsView',
        payload: { ...tipsViewState, data: { ...tipsViewState?.data, [payload?.[0]]: true } },
      });
      yield call(setTipsViewStateTrue, { tags: payload?.join(',') });
    },
  },
  reducers: {
    updateTipsView(state, action) {
      return { ...state, ...action?.payload };
    },
  },
};

export default TipsViewModel;
